import styled from 'styled-components';

import { Layer } from '../../theme';

export const MiniPopupsContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: ${Layer.AlertBar};
`;
